"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AveragePriceIndication = void 0;
const price_avaliation_enum_1 = require("../../@types/outcoming/enum/price-avaliation.enum");
class AveragePriceIndication {
    getIndication(data) {
        const { Last: lastPrice, Summary: summaryPrice } = data;
        const { Average: averagePrice, High: highPrice, Low: lowPrice, } = summaryPrice;
        const { Price: actualPrice } = lastPrice;
        const output = {
            averagePrice,
            avaliation: price_avaliation_enum_1.ePriceAvaliation.NEUTRAL,
            internalPoints: 0,
        };
        if (actualPrice > averagePrice) {
            if (actualPrice >= highPrice) {
                output.avaliation = price_avaliation_enum_1.ePriceAvaliation.HORRIBLE;
                output.internalPoints = 1;
            }
            else {
                output.avaliation = price_avaliation_enum_1.ePriceAvaliation.BAD;
            }
        }
        else {
            if (lowPrice >= actualPrice) {
                output.avaliation = price_avaliation_enum_1.ePriceAvaliation.VERY_GOOD;
            }
            else {
                output.avaliation = price_avaliation_enum_1.ePriceAvaliation.GOOD;
            }
        }
        return output;
    }
}
exports.AveragePriceIndication = AveragePriceIndication;
//# sourceMappingURL=average-price-indication.js.map